export type RelationSide = 'parents' | 'children';
export interface RelationAsset { id: number; title: string; regulationId: number }
export interface AssetRelations {
  asset: RelationAsset;
  project: { id: number; title: string };
  regulations: Array<{ id: number; title: string }>;
  candidates: RelationAsset[];
  parents: number[];
  children: number[];
  version: string;
  protectedCount: number;
}
export interface RelationChanges {
  expectedVersion: string;
  addParents: number[]; removeParents: number[];
  addChildren: number[]; removeChildren: number[];
}
export function relationChanges(data: AssetRelations, parents: Set<number>, children: Set<number>): RelationChanges {
  const previousParents = new Set(data.parents), previousChildren = new Set(data.children);
  return {
    expectedVersion: data.version,
    addParents: [...parents].filter(id => !previousParents.has(id)),
    removeParents: data.parents.filter(id => !parents.has(id)),
    addChildren: [...children].filter(id => !previousChildren.has(id)),
    removeChildren: data.children.filter(id => !children.has(id)),
  };
}
// Indices refer to the full filtered list, including rows outside the viewport.
export function selectRange(before: Set<number>, rows: RelationAsset[], from: number, to: number, checked: boolean): Set<number> {
  const next = new Set(before);
  for (let index = Math.max(0, Math.min(from, to)); index <= Math.min(rows.length - 1, Math.max(from, to)); index++) {
    if (checked) next.add(rows[index].id); else next.delete(rows[index].id);
  }
  return next;
}
